/**
 * Son görülenin cihazdaki kopyası (28 Eki 2026, kullanıcı: "Instagram gibi").
 *
 * Menü, masalar, salonlar, kampanyalar, kurum ayarları ve oturum her
 * değiştiğinde buraya yazılıyor. Uygulama açılınca önce bu kopya ekrana gelir,
 * sunucunun tazesi arkadan yerine oturur; internetsizken de son bilinen hal
 * görünür. Siparişler ayrı, kendi IndexedDB önbelleğinde (services/sync).
 *
 * localStorage, çünkü ilk çizimde eşzamanlı okunabiliyor: IndexedDB'yi
 * beklemek o ilk karede yine boş ekran demek. Veriler küçük (yüzlerce ürün).
 * Yazılamazsa (gizli sekme, dolu depo) sessizce geçilir, uygulama eskisi gibi
 * sunucudan okur.
 */
const PREFIX = 'adissoo.cache.'

function key(scope: string, name: string): string {
  return `${PREFIX}${scope}.${name}`
}

export function readCache<T>(scope: string | null | undefined, name: string): T | null {
  if (!scope) return null
  try {
    const raw = localStorage.getItem(key(scope, name))
    return raw ? (JSON.parse(raw) as T) : null
  } catch {
    return null
  }
}

export function writeCache(scope: string | null | undefined, name: string, value: unknown): void {
  if (!scope) return
  try {
    localStorage.setItem(key(scope, name), JSON.stringify(value))
  } catch {
    // Depo dolu ya da kapalı: kopya yok, uygulama sunucudan okumaya devam eder.
  }
}

export function clearCache(scope: string, name: string): void {
  try {
    localStorage.removeItem(key(scope, name))
  } catch {
    /* yoksay */
  }
}

/** Sunucudan en son ne zaman taze veri geldi (bağlantı rozeti gösteriyor). */
const SYNCED = 'adissoo.lastSync'
const listeners = new Set<(at: number) => void>()

export function markSynced(at: number = Date.now()): void {
  try {
    localStorage.setItem(SYNCED, String(at))
  } catch {
    /* yoksay */
  }
  listeners.forEach((fn) => fn(at))
}

export function lastSynced(): number | null {
  try {
    const v = Number(localStorage.getItem(SYNCED))
    return Number.isFinite(v) && v > 0 ? v : null
  } catch {
    return null
  }
}

export function onSynced(fn: (at: number) => void): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
